export const MIN_SPACER_HEIGHT = 2;
